import React from 'react'
import dayjs from 'dayjs'
import { Avatar, message } from 'antd'
import Icon from '@forwardflow/ui/Icons'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'

interface MessageItemProps {
   item: any
}

export const AgentMessageItem: React.FC<MessageItemProps> = ({ item }) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })

   const stripHtml = (html: string) => {
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
   }

   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }

   return (
      <div className="flex items-end justify-end gap-x-2">
         <div className="flex flex-col justify-between bg-[#594180] py-4 px-5 max-w-[450px] rounded-3xl rounded-br-none gap-y-1">
            {user?.email === 'operator@forward-flow.com' && item?.stepId && (
               <div className="text-[11px] mb-1 text-white/70 flex gap-x-4">
                  <span
                     className="cursor-pointer select-all"
                     title="Click to copy"
                     onClick={handleCopy}
                  >
                     Step Id:{' '}
                     <span className="text-[12px] font-medium">
                        {item?.stepId}
                     </span>
                  </span>
                  {item?.campaignPhase && (
                     <span>
                        Phase:{' '}
                        <span className="text-[12px] font-medium">
                           {item?.campaignPhase}
                        </span>
                     </span>
                  )}
                  {item?.campaignType && (
                     <span>
                        Type:{' '}
                        <span className="text-[12px] font-medium">
                           {item?.campaignType}
                        </span>
                     </span>
                  )}
               </div>
            )}

            <p className="text-[14px]">{stripHtml(item?.content)}</p>
            <div className="flex items-center justify-end gap-x-3">
               <p className="text-[10px] text-white/70">
                  {/* Sent by {item?.assistant?.name},{' '} */}
                  {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
               </p>
               {false && (
                  <>
                     <div className="cursor-pointer">
                        <Icon
                           name="Like"
                           className={`${
                              item?.data?.meta?.isLiked
                                 ? 'fill-[#FEE505]'
                                 : 'fill-[#CDB4F3]'
                           }`}
                        />
                     </div>
                     <div className="cursor-pointer">
                        <Icon
                           name="Like"
                           className={`rotate-180 ${
                              item?.data?.meta?.isDisLiked
                                 ? 'fill-[#FEE505]'
                                 : 'fill-[#CDB4F3]'
                           }`}
                        />
                     </div>
                     <div className="flex items-center cursor-pointer gap-x-1">
                        <span className="text-[10px] text-white/70">
                           {item?.data?.meta?.totalFeedbacks || ''}
                        </span>
                        <Icon
                           name="Comment"
                           className={`${
                              item?.data?.meta?.totalFeedbacks
                                 ? 'fill-[#FEE505]'
                                 : 'fill-[#CDB4F3]'
                           }`}
                        />
                     </div>
                  </>
               )}
            </div>
         </div>
         <Avatar
            src={'/images/ff_white.png'}
            className="w-10 h-10 p-1 bg-primary/10 shrink-0"
         >
            {item?.assistant?.name.slice(0, 1) || 'A'}
         </Avatar>
      </div>
   )
}
